import styles from './styles.module.scss';
import ConfirmationMethodSelectEmail from './Emails';
import { ConfirmationMethodSelectProps } from './props';

/**
 * Component that renders a confirmation method selection interface
 * Displays a title and email selection component
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.title - Title text to display above selection
 * @param {bigint|null} props.currentId - Currently selected method ID
 * @param {Function} props.onEmailSelect - Callback when email is selected
 * @param {boolean} props.withoutPadding - Whether to remove container padding
 * @returns {JSX.Element} Container with title and email selection component
 */
export default function ConfirmationMethodSelect({
  title,
  currentId,
  onEmailSelect,
  withoutPadding,
}: ConfirmationMethodSelectProps) {
  return (
    <div
      className={`${styles.container} ${withoutPadding ? styles['container--no-padding'] : ''}`}
    >
      <p className={styles.container__description}>{title}</p>
      <ConfirmationMethodSelectEmail
        callback={onEmailSelect}
        currentId={currentId}
      />
    </div>
  );
}
